import React from 'react';
import './LoadingScreen.css';
import logoTr from '../../assets/Logo-tr.svg';
import logoEn from '../../assets/Logo-en.svg';
import { useTranslation } from 'react-i18next';

const LoadingScreen = () => {
    const { i18n } = useTranslation();

    // Dil bulma mantığı: En yüksek öncelik kullanıcının kaydettiği localStorage bilgisidir.
    let currentLang = 'tr'; // varsayılan
    try {
        const localData = localStorage.getItem('localization');
        if (localData) {
            const parsed = JSON.parse(localData);
            if (parsed && parsed.code) {
                currentLang = parsed.code;
            }
        } else if (i18n?.language) {
            currentLang = i18n.language.split('-')[0];
        }
    } catch (error) {
        if (i18n?.language) {
            currentLang = i18n.language.split('-')[0];
        }
    }

    const isEnglish = currentLang === 'en';
    const activeLogo = isEnglish ? logoEn : logoTr;
    const loadingText = isEnglish ? 'Loading...' : 'Yükleniyor...';

    return (
        <div className="loading-screen">
            <div className="loading-content">
                <div className="loading-logo-container">
                    <img src={activeLogo} alt="MNG Airlines Logo" className="loading-logo" width="200" height="80" />
                </div>
                <div className="loading-spinner-container">
                    <div className="loading-spinner"></div>
                </div>
                <div className="loading-text">{loadingText}</div>
            </div>
        </div>
    );
};

export default LoadingScreen;
